import type { MembershipPlan } from '@atomfit/shared';

type MarketingPlan = Pick<
  MembershipPlan,
  'tier' | 'marketingWeeklyPriceInSmallestUnit' | 'priceInSmallestUnit' | 'slotsPerMonth'
>;

export function membershipHourlyMarketingPrice(plan: MarketingPlan): number {
  const weeklyPrice = Number.isFinite(plan.marketingWeeklyPriceInSmallestUnit)
    ? plan.marketingWeeklyPriceInSmallestUnit
    : plan.tier === 'PREMIUM'
      ? 119000
      : plan.tier === 'ELITE'
        ? 189000
        : Math.round(plan.priceInSmallestUnit / 4.333);
  const defaultSlots = { BASIC: 12, PREMIUM: 24, ELITE: 48 };
  const slotsPerMonth =
    plan.slotsPerMonth !== null && Number.isFinite(plan.slotsPerMonth) && plan.slotsPerMonth > 0
      ? plan.slotsPerMonth
      : defaultSlots[plan.tier];

  // Marketing uses four training weeks per month and two 30-minute slots per hour.
  // Premium: 1,190 / 3 = 397 CZK; Elite: 1,890 / 6 = 315 CZK after display rounding.
  return Math.round((weeklyPrice * 4 * 2) / slotsPerMonth);
}
